import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constant/colors";

const CertificateManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "white",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    padding: "18px 20px",
    display: "flex",
    alignItems: "center",
    gap: "18px",
    cursor: "pointer",
    transition: "0.2s",
    minHeight: "120px",
    height: "100%",
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
  };

  const subheading = {
    fontSize: "12px",
    opacity: 0.8,
    marginTop: "4px",
  };

  const iconStyle = {
    fontSize: "32px",
    minWidth: "40px",
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  return (
    <div
      style={{ background: "#ffffff", minHeight: "100vh" }}
      className="flex justify-center items-start "
    >
      <div className="w-full max-w-full px-0 p-2 md:px-6 lg:px-12 pt-8 pb-12">

        {/* Page Title */}
       
        {/* Grid Layout */}
        <div
        className={`grid gap-6 w-full ${isMobile ? "grid-cols-1" : "grid-cols-3"}`}
        style={{ alignItems: "stretch" }}
        >

          {/* School Leaving Certificate */}
          <Link to="/school-leaving-certificate" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i
                className="fas fa-graduation-cap"
                style={{ ...iconStyle, color: "#F97316" }}
              ></i>
              <div>
                <h2 style={heading}>School Leaving Certificate</h2>
                <p style={subheading}>
                  View and manage school leaving certificates for students.
                </p>
              </div>
            </div>
          </Link>

          {/* Date of Birth Certificate */}
          <Link to="/dob-certificate" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i
                className="fas fa-calendar-alt"
                style={{ ...iconStyle, color: "purple" }}
              ></i>
              <div>
                <h2 style={heading}>Date of Birth Certificate</h2>
                <p style={subheading}>
                  Manage date of birth certificates for students.
                </p>
              </div>
            </div>
          </Link>

          {/* Character Certificate */}
          <Link to="/character-certificate" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i
                className="fas fa-user-shield"
                style={{ ...iconStyle, color: colors.primary }}
              ></i>
              <div>
                <h2 style={heading}>Character Certificate</h2>
                <p style={subheading}>
                  View and manage character certificates for students.
                </p>
              </div>
            </div>
          </Link>

          {/* Family Income Certificate */}
          <Link to="/family-income-certificate" className="flex">
            <div style={cardStyle} className="hover:scale-[1.01] w-full">
              <i
                className="fas fa-coins"
                style={{ ...iconStyle, color: "#EAB308" }}
              ></i>
              <div>
                <h2 style={heading}>Family Income Certificate</h2>
                <p style={subheading}>
                  Manage family income certificates for students.
                </p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CertificateManagement;
